<script lang="ts" setup>
import SpritePlatforms from '@/assets/images/platforms/sprite-platforms.svg';

import { createCustomList } from '@/helpers/utils';

const { t } = useLocales();

const properties = createCustomList(6, (i) => ({
  label: t(`pricing.payment_props.list[${i}]`),
}));

const platforms: { icon: string }[] = [
  { icon: 'windows' },
  { icon: 'finder' },
  { icon: 'android' },
  { icon: 'ios' },
  { icon: 'router_wi-fi' },
  { icon: 'chrome' },
  { icon: 'firefox' },
  { icon: 'fire_tv_rectangle' },
  { icon: 'apple_tv' },
  { icon: 'smart_tv' },
];
</script>

<template>
  <div class="payment-props">
    <p class="payment-props__title text-body-xl text-weight-bold">
      {{ t('pricing.payment_props.title') }}
    </p>

    <ul class="payment-props__list">
      <li
        v-for="(prop, idx) in properties"
        :key="idx"
        class="payment-props__item text-body-sc"
      >
        {{ prop.label }}
      </li>

      <li class="payment-props__item payment-props__item--platforms">
        <span
          v-for="platform in platforms"
          :key="platform.icon"
          class="payment-props__platform"
        >
          <svg
            class="payment-props__platform-icon"
            width="12"
            height="12"
          >
            <use :xlink:href="`${SpritePlatforms}#${platform.icon}`"></use>
          </svg>
        </span>
      </li>
    </ul>
  </div>
</template>

<style lang="scss" scoped>
.payment-props {
  $this: 'payment-props';

  &__title {
    margin-bottom: 12px;
  }

  &__list {
    @include reset-list;

    // margin-bottom: 24px;

    // @include media('md') {
    //   margin-bottom: 36px;
    // }
  }

  &__item {
    display: flex;
    column-gap: 8px;
    color: $color-new-black-500;

    &:not(:last-child) {
      margin-bottom: 12px;
    }

    &::before {
      content: '';
      display: block;
      width: 16px;
      height: 16px;
      margin-top: 2px;
      background: url('@/assets/images/check-icon.svg') no-repeat center;
    }
  }

  &__platforms {
    &::before {
      margin-right: 4px;
    }
  }

  &__platform {
    display: inline-flex;
    width: 20px;
    height: 20px;
  }

  &__platform-icon {
    fill: $color-dark-blue-400;
    margin: auto;
  }
}
</style>
